import { Component, inject } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SiaJsonEditorComponent } from '@sia/code-editor';
import { SiaTranslatePipe } from '@sia/shared';
@Component({
  selector: 'sia-template-export-dialog',
  standalone: true,
  imports: [
    SiaJsonEditorComponent,
    MatDialogTitle,
    MatDialogActions,
    MatDialogClose,
    SiaTranslatePipe,
    MatIconButton,
    MatButton,
    MatIcon,
    MatDialogContent,
  ],
  templateUrl: './template-export-dialog.component.html',
  styleUrl: './template-export-dialog.component.scss',
})
export class SiaTemplateExportDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<SiaTemplateExportDialogComponent>>(MatDialogRef);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  download() {
    const blob = new Blob([this.data], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'template.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
